// extracted by mini-css-extract-plugin
module.exports = {"section":"Intro_section__UH9Kc","bg":"Intro_bg__6VQoR","logo":"Intro_logo__Tlago"};